<template>
  <div class="flex flex-col items-center justify-center gap-2 w-full">
    <LegendasHeader
      :metaTotal="metaTotal"
      :totalVendas="totalVendas"
      :currentRelogio="currentRelogio"
      :totalRelogio="totalRelogio"
    />
    <ProgressBar
      :isLoading="isLoading"
      :percentageWorkingDay="percentageWorkingDay"
      :percentageTarget="percentageTarget"
      :totalVendas="totalVendas"
    />
  </div>
</template>

<script>
import {
  calculateWorkingDays,
  totalWorkingDaysInDate,
} from '../utils/eh-dia-util';
import LegendasHeader from './LegendasHeader.vue';
import ProgressBar from './ProgressBar.vue';

export default {
  name: 'ProgressBarWithLegend',
  props: {
    finalDate: {
      type: String,
    },
    isPainelGeral: {
      type: Boolean,
      default: false,
    },
    supervisor: {
      type: Object,
      default: () => ({}),
    },
    dataSend: {
      type: Object,
      default: () => ({}),
    },
    metaTotalDivisao: {
      type: Object,
      default: () => ({}),
    },
    isAnnualPodium: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fetchedTotalVendas: 0,
      temporaryTables: null,
      divisao: {
        somaMetaSupervisores: 0,
        totalRelogio: 0,
        somaVendasSupervisores: 0,
      },
    };
  },

  watch: {
    metaTotalDivisao() {
      this.divisao = this.metaTotalDivisao;
    },
  },

  computed: {
    currentRelogio() {
      const dateWithTime = this.finalDate + 'T00:00:00';
      return calculateWorkingDays(new Date(dateWithTime));
    },
    percentageWorkingDay() {
      const newDate = new Date(this.finalDate);
      const daysOfWorking = totalWorkingDaysInDate(newDate);

      const percentage = (this.currentRelogio / daysOfWorking) * 100;
      return percentage;
    },
    percentageTarget() {
      const percentage = (this.totalVendas / this.metaTotal) * 100;
      return percentage;
    },
    metaTotal() {
      return this.isPainelGeral
        ? this.supervisor.metaTotal
        : this.divisao.somaMetaSupervisores;
    },
    totalVendas() {
      return this.isPainelGeral
        ? this.supervisor.totalVendas
        : this.divisao.somaVendasSupervisores;
    },
    totalRelogio() {
      return this.isPainelGeral
        ? this.supervisor.relogio
        : this.divisao.totalRelogio;
    },
  },

  components: { LegendasHeader, ProgressBar },

  async mounted() {
    if (this.isAnnualPodium) {
      return;
    }
  },
};
</script>
